// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._19bvidpf{padding-left:0}
._ca0qidpf{padding-top:0}
._n3tdidpf{padding-bottom:0}
._s7n41ndm{vertical-align:text-bottom}
._u5f3idpf{padding-right:0}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/InlineCard/ResolvingView/styled.compiled.css"],"names":[],"mappings":"AAAA,WAAW,cAAc;AACzB,WAAW,aAAa;AACxB,WAAW,gBAAgB;AAC3B,WAAW,0BAA0B;AACrC,WAAW,eAAe","sourcesContent":["._19bvidpf{padding-left:0}\n._ca0qidpf{padding-top:0}\n._n3tdidpf{padding-bottom:0}\n._s7n41ndm{vertical-align:text-bottom}\n._u5f3idpf{padding-right:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
